import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=2936e39a"
import script from "./TicketItem.js?vue&type=script&lang=js&external"
export * from "./TicketItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports